export default function reducer(
  state = [],
  { type, payload }: { type: String; payload: {} }
): any {
  //work with state
  switch (type) {
    case "SET_USER_STATE":
      return { ...state, userMetadata: payload };
    case "SET_DASHBOARD_DATA":
      return { ...state, dashboardData: payload };
    case "SET_TIMESERIES_DATA":
      return { ...state, timeSeriesData: payload };
  }
  return state;
}
